module.exports = __webpack_public_path__ + "static/media/avatar.bd20acb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/avatar.jpg
// module id = 187
// module chunks = 0